import { Controller } from '@hotwired/stimulus'
import flatpickr from '~/vendors/flatpickr'

export default class extends Controller {
  static values = {
    openAtConnect: Boolean
  }

  connect() {
    flatpickr(this.element, this.options())
  }

  open() {
    flatpickr(this.element, this.options()).open()
  }

  options() {
    const options = {
      altInput: true,
      altFormat: 'd/m/Y',
      dateFormat: 'Y-m-d',
      allowInput: true,
      onChange: function (_selectedDates, _dateStr, instance) {
        instance.altInput.blur()
      }
    }

    return options
  }
}
